import api from "./api";

export type Perfil = "funcionario" | "suporte" | "gestor" | "admin" | "cliente";

export interface Usuario {
  id: string;
  nome: string;
  email: string;
  perfil: Perfil;
  ativo: boolean;
  criadoEm: string;
  fotoUrl?: string | null;
  /** Para perfil="cliente": projeto único que ele vê no portal. */
  projetoVisivelId?: string | null;
  clienteId?: string | null;
  // Dados profissionais (PDF — Cadastro de colaborador)
  cargo?: string | null;
  /** Nível profissional (junior/pleno/senior) — cruza horas vendidas×realizadas. */
  nivel?: string | null;
  /** Vínculo contratual — só selo visual (clt/pj/terceirizado). */
  vinculo?: string | null;
  /** Selo "Atendente" — só exibição, não muda permissão. */
  ehAtendente?: boolean;
  /** Setor/equipe (Produção/Atendimento/Gestão…) — agrupa a Produtividade. */
  setor?: string | null;
  /** Função padrão nas tarefas — sugestão ao alocar a pessoa num card. */
  funcaoPadrao?: string | null;
  telefone?: string | null;
  whatsapp?: string | null;
  dataNascimento?: string | null;     // ISO
  fusoHorario?: string | null;
  entrouEmpresaEm?: string | null;    // ISO
  /** Visível apenas para admin/gestor. */
  custoHora?: number | null;
}

export interface ColaboradorInput {
  cargo?: string | null;
  nivel?: string | null;
  vinculo?: string | null;
  ehAtendente?: boolean;
  setor?: string | null;
  funcaoPadrao?: string | null;
  telefone?: string | null;
  whatsapp?: string | null;
  dataNascimento?: string | null;
  fusoHorario?: string | null;
  entrouEmpresaEm?: string | null;
  custoHora?: number | null;
}

export async function listarUsuarios() {
  const r = await api.get("/usuarios");
  return r.data.data as Usuario[];
}

export async function criarUsuario(dados: { nome: string; email: string; senha: string; perfil: Perfil; projetoVisivelId?: string | null; clienteId?: string | null } & ColaboradorInput) {
  const r = await api.post("/usuarios", dados);
  return r.data.data as Usuario;
}

export async function atualizarUsuario(id: string, dados: Partial<{ nome: string; email: string; senha: string; perfil: Perfil; ativo: boolean; projetoVisivelId: string | null; clienteId: string | null } & ColaboradorInput>) {
  const r = await api.patch(`/usuarios/${id}`, dados);
  return r.data.data as Usuario;
}

export async function desativarUsuario(id: string) {
  await api.delete(`/usuarios/${id}`);
}

export async function excluirUsuarioPermanente(id: string, forcar: boolean) {
  const url = `/usuarios/${id}/permanente${forcar ? "?forcar=true" : ""}`;
  await api.delete(url);
}
